/**
 * Centralized dev-tools gate.
 *
 * The dev/test affordances (the home Test Mode panel, the assessment autopilot,
 * the dev navigation helper, the legacy assessment simulator, and the
 * /results-test preview) must NOT be exposed to real coaches/clients. Staging is
 * production-in-use, so a plain NODE_ENV check is not enough: Dan still needs to
 * run on-phone test passes there, and the headless harness drives the autopilot
 * on staging.
 *
 * Dev tools are enabled when ANY of:
 *   - the build is a local dev build (NODE_ENV !== 'production'), or
 *   - the build was made with REACT_APP_DEV_TOOLS=true, or
 *   - a per-device opt-in flag is set in localStorage.
 *
 * The per-device flag is toggled via a URL param so it can be flipped on a phone
 * or in the headless harness without a rebuild: load any page with ?dev=1 to
 * enable, or ?dev=0 to disable. The choice sticks for that browser/device.
 */

const DEV_FLAG_KEY = 'apcDevTools';
// Honored so any device previously enabled via the old DevNavigationHelper key
// stays on, and so the two gates share one source of truth.
const LEGACY_DEV_FLAG_KEY = 'show-dev-tools';

export function isDevToolsEnabled() {
  if (process.env.NODE_ENV !== 'production') return true;
  if (process.env.REACT_APP_DEV_TOOLS === 'true') return true;
  try {
    return (
      localStorage.getItem(DEV_FLAG_KEY) === '1' ||
      localStorage.getItem(LEGACY_DEV_FLAG_KEY) === 'true'
    );
  } catch (e) {
    return false;
  }
}

// Read ?dev=1 / ?dev=0 from the URL once on app load and persist the choice.
// Safe to call before render; never throws.
export function syncDevToolsFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('dev')) return;
    const v = params.get('dev');
    if (v === '1' || v === 'true') {
      localStorage.setItem(DEV_FLAG_KEY, '1');
    } else if (v === '0' || v === 'false') {
      localStorage.removeItem(DEV_FLAG_KEY);
      localStorage.removeItem(LEGACY_DEV_FLAG_KEY);
    }
  } catch (e) {
    /* localStorage or URL unavailable; ignore */
  }
}
